import React from 'react';

const pairOffs: React.FC = () => <div>REPO PAIROFFS</div>; // TODO: RPO-46

export default pairOffs;